import wx from 'weixin-js-sdk'; // 微信sdk 版本号是1.6.0
import { Dialog } from 'vant';
import http from './http'
import store from '@/store'

let APPID;
if(typeof localStorage.basicInfo != 'undefined') {
    APPID = JSON.parse(localStorage.basicInfo).wxAppId;
}


export default {
    initOpenId() {
        return new Promise((resolve, reject)=>{
            const timestamp = new Date();
            const REDIRECT_URI = encodeURIComponent(window.location.href);
            let url = `https://wxjump.yjmbank.cn/get-weixin-code.html?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base&state=${timestamp}#wechat_redirect`;
            console.warn('跳转过去', Utils.getUrlArg('code'), typeof Utils.getUrlArg('code'));
            window.location.replace(url);
        }).catch((e)=>{
            
        })
    },
    initNick(){
        return new Promise((resolve, reject)=>{
            const REDIRECT_URI = encodeURIComponent(window.location.href);
            const timestamp = new Date();
            let url = `https://wxjump.yjmbank.cn/get-weixin-code.html?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=${timestamp}#wechat_redirect`;
            console.warn('跳转过去', Utils.getUrlArg('code'), );
            console.warn('路由参数',this.$route.query)
            localStorage.isScope = 1;
            window.location.replace(url);
        }).catch((e)=>{
            
        })
    }
}